module.exports = "/virtual-football-league/img/amblems/left/logos/NewCastle.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/left/logos/NewCastle.png
// module id = 2114
// module chunks = 4